import StoreHelper from '/@/modules/core/app/helpers/StoreHelper';
import { CommitHelperInterface } from '@/modules/core/app/helpers/interfaces/CommitHelperInterface';
import { GetterHelperInterface } from '@/modules/core/app/helpers/interfaces/GetterHelperInterface';
import { StateHelperInterface } from '@/modules/core/app/helpers/interfaces/StateHelperInterface';

// @ts-ignore
export const commits: CommitHelperInterface = new Proxy(StoreHelper, {
  get(target, name: string): unknown {
    if (name in target) {
      return target[name as keyof typeof target];
    }
    // Return the store itself, as Pinia stores have actions directly accessible
    return StoreHelper[name as keyof typeof StoreHelper];
  }
});

// @ts-ignore
export const getters: GetterHelperInterface = new Proxy(StoreHelper, {
  get(target, name: string): unknown {
    if (name in target) {
      return target[name as keyof typeof target];
    }
    // Return the store itself, as Pinia stores have getters directly accessible
    return StoreHelper[name as keyof typeof StoreHelper];
  }
});

// @ts-ignore
export const state: StateHelperInterface = new Proxy(StoreHelper, {
  get(target, name: string): unknown {
    if (name in target) {
      return target[name as keyof typeof target];
    }
    // Return the store itself, as Pinia stores have state directly accessible
    return StoreHelper[name as keyof typeof StoreHelper];
  }
});
